export const SEGMENT_COHORT_SCOPE_STORAGE_KEY = 'nm.segmentCohortScope';

/**
 * All selected serials (CAPs + Nodes) that form a segmentation cohort.
 * Segment partitioning needs at least one CAP in the cohort to act as a
 * segment root, so callers should guard with `selectionHasCap` first.
 */
export function extractSegmentCohortSerials(selectedDevices) {
  const serials = new Set();
  (selectedDevices || []).forEach((device) => {
    const serial = String(device?.serial_number || '').trim();
    if (serial) serials.add(serial);
  });
  return [...serials];
}

/** True when the selection includes at least one CAP device. */
export function selectionHasCap(selectedDevices, isCapDevice) {
  return (selectedDevices || []).some((device) => device?.serial_number && isCapDevice(device));
}

export function persistSegmentCohortScope({ serials } = {}) {
  if (!Array.isArray(serials) || serials.length === 0) return;
  const cleaned = serials
    .map((s) => String(s || '').trim().toLowerCase())
    .filter(Boolean);
  if (cleaned.length === 0) return;
  sessionStorage.setItem(
    SEGMENT_COHORT_SCOPE_STORAGE_KEY,
    JSON.stringify({ serials: [...new Set(cleaned)] }),
  );
}

export function consumeSegmentCohortScope() {
  try {
    const raw = sessionStorage.getItem(SEGMENT_COHORT_SCOPE_STORAGE_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(SEGMENT_COHORT_SCOPE_STORAGE_KEY);
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed?.serials) || parsed.serials.length === 0) {
      return null;
    }
    return parsed;
  } catch {
    sessionStorage.removeItem(SEGMENT_COHORT_SCOPE_STORAGE_KEY);
    return null;
  }
}
